// FinTrack — CRUD operacije (Vrste, Komitenti, Users, Quick Assign)
// Sve write operacije idu kroz SECURITY DEFINER RPC funkcije
// Sav korisnicki unos se eskejpuje pomocu esc() funkcije pre renderovanja

import { state, ALL_TABS } from './state.js';
import { sb } from './supabase.js';
import { toast, showLoading, hideLoading, clMdl, svgIcon, showConfirm } from './ui.js';
import { esc, fNum } from './utils.js';
import { loadAllData } from './nav.js';
import { renderReport } from './report.js';
import XLSX from 'xlsx-js-style';

// HELPER
export function popVS(sid,sel){
  const el=document.getElementById(sid);
  el.textContent='';
  const def=document.createElement('option');def.value='';def.textContent='\u2014';el.appendChild(def);
  state.vrsteData.forEach(v=>{
    const o=document.createElement('option');o.value=v.id;o.textContent=v.icon+' '+v.name_en;
    if(v.id==sel)o.selected=true;el.appendChild(o);
  });
}

// VRSTE TROSKOVA — with drag & drop reorder
let dragSrcRow = null;

export function renderVrste(){
  const tbody=document.getElementById('vrBody');
  tbody.textContent='';
  state.vrsteData.forEach((v,i)=>{
    const c=state.komData.filter(k=>k.vrsta_troska_id===v.id).length;
    const tr=document.createElement('tr');
    tr.draggable=true;
    tr.dataset.id=v.id;
    tr.style.cursor='grab';
    tr.ondragstart=(e)=>{dragSrcRow=tr;tr.style.opacity='.4';e.dataTransfer.effectAllowed='move';};
    tr.ondragend=()=>{tr.style.opacity='';};
    tr.ondragover=(e)=>{e.preventDefault();e.dataTransfer.dropEffect='move';tr.style.borderTop='2px solid var(--acc)';};
    tr.ondragleave=()=>{tr.style.borderTop='';};
    tr.ondrop=(e)=>{e.preventDefault();tr.style.borderTop='';if(dragSrcRow&&dragSrcRow!==tr){tbody.insertBefore(dragSrcRow,tr);saveVrsteOrder();}};
    const td0=document.createElement('td');td0.style.cssText='color:var(--tx3);cursor:grab';td0.appendChild(svgIcon('menu',14));td0.title='Prevuci za reorder';
    const td1=document.createElement('td');td1.style.color='var(--tx3)';td1.textContent=i+1;
    const td2=document.createElement('td');const strong=document.createElement('strong');strong.textContent=v.name_en;td2.appendChild(strong);
    const td3=document.createElement('td');td3.style.color='var(--tx2)';td3.textContent=v.name_sr;
    const td4=document.createElement('td');td4.style.textAlign='center';td4.style.fontSize='20px';td4.textContent=v.icon;
    const td5=document.createElement('td');td5.className='num';td5.textContent=c;
    const td6=document.createElement('td');
    const acts=document.createElement('div');acts.style.display='flex';acts.style.gap='4px';acts.style.justifyContent='flex-end';
    const btnE=document.createElement('button');btnE.className='bico';btnE.appendChild(svgIcon('edit',14));btnE.onclick=()=>editVrsta(v.id);
    const btnD=document.createElement('button');btnD.className='bico del';btnD.appendChild(svgIcon('trash',14));btnD.onclick=()=>delVrsta(v.id,v.name_en);
    acts.appendChild(btnE);acts.appendChild(btnD);td6.appendChild(acts);
    tr.appendChild(td0);tr.appendChild(td1);tr.appendChild(td2);tr.appendChild(td3);tr.appendChild(td4);tr.appendChild(td5);tr.appendChild(td6);
    tbody.appendChild(tr);
  });
if(!state.vrsteData.length){const p=document.createElement('tr');const td=document.createElement('td');td.colSpan=7;td.style.cssText='text-align:center;padding:30px;color:var(--tx3)';td.textContent='Nema vrsta troškova. Kliknite "+ Dodaj" da dodate.';p.appendChild(td);tbody.appendChild(p);}
}

async function saveVrsteOrder(){
  const tbody=document.getElementById('vrBody');
  const ids=[...tbody.querySelectorAll('tr[data-id]')].map(tr=>parseInt(tr.dataset.id));
  // Reorder local state
  const ordered=[];
  ids.forEach(id=>{const v=state.vrsteData.find(x=>x.id===id);if(v)ordered.push(v);});
  state.vrsteData.splice(0,state.vrsteData.length,...ordered);
  renderVrste();
  try{
    const{error}=await sb.rpc('reorder_vrste',{p_user_id:state.CU.id,p_ids:ids});
    if(error)throw error;
    toast('Redosled sačuvan');
  }catch(e){toast('Greška: '+e.message,'err');}
}
export function showAddVrsta(){document.getElementById('mvTitle').textContent='Dodaj vrstu';document.getElementById('mvEn').value='';document.getElementById('mvSr').value='';document.getElementById('mvIco').value='\u2699\uFE0F';document.getElementById('mvId').value='';document.getElementById('mdlVrsta').classList.add('active');}
export function editVrsta(id){const v=state.vrsteData.find(x=>x.id===id);if(!v)return;document.getElementById('mvTitle').textContent='Izmeni';document.getElementById('mvEn').value=v.name_en;document.getElementById('mvSr').value=v.name_sr;document.getElementById('mvIco').value=v.icon;document.getElementById('mvId').value=v.id;document.getElementById('mdlVrsta').classList.add('active');}

export async function saveVrsta(){
  const en=document.getElementById('mvEn').value.trim();
  const sr=document.getElementById('mvSr').value.trim();
  const ico=document.getElementById('mvIco').value.trim()||'\u2699\uFE0F';
  const id=document.getElementById('mvId').value;
  if(!en){toast('Unesite naziv','err');return;}
  try{
    const{error}=await sb.rpc('upsert_vrsta',{
      p_user_id:state.CU.id, p_name_en:en, p_name_sr:sr, p_icon:ico,
      p_sort_order:id?undefined:state.vrsteData.length+1,
      p_vrsta_id:id?parseInt(id):null
    });
    if(error)throw error;
    clMdl('mdlVrsta');await loadAllData();toast(id?'A\u017eurirano':'Dodato');
  }catch(e){toast(e.message||'Greška pri čuvanju','err');}
}

export async function delVrsta(id,name){
  const c=state.komData.filter(k=>k.vrsta_troska_id===id).length;
  const msg='Da li ste sigurni da želite da obrišete vrstu troška "'+name+'"?'+(c>0?'\n\n⚠ '+c+' komitent(a) koristi ovu kategoriju i biće bez kategorije.':'');
  showConfirm(msg, async () => { try{
    const{error}=await sb.rpc('delete_vrsta',{p_user_id:state.CU.id,p_vrsta_id:id});
    if(error)throw error;
    await loadAllData();toast('Obrisano');
    if(c>0) toast(c+' komitent(a) nema kategoriju — dodelite im novu','warn');
  }catch(e){toast(e.message||'Greška pri brisanju','err');} });
}

// KOMITENTI
export function renderKom(){
  const s=(document.getElementById('komSrch')?.value||'').toLowerCase();
  const fl=s?state.komData.filter(k=>k.name.toLowerCase().includes(s)):state.komData;
  const g={};for(const v of state.vrsteData)g[v.id]={v:v,items:[]};g['_']={v:{name_en:'Neraspoređeni',icon:'\u26A0\uFE0F'},items:[]};
  for(const k of fl){const gid=k.vrsta_troska_id||'_';if(g[gid])g[gid].items.push(k);else g['_'].items.push(k);}
  const box=document.getElementById('komBox');
  box.textContent='';
  let hasItems=false;
  for(const[gid,gr] of Object.entries(g)){
    if(!gr.items.length)continue;
    hasItems=true;
    const sec=document.createElement('div');sec.className='vsec';
    const hdr=document.createElement('div');hdr.className='vhdr';
    const hl=document.createElement('div');hl.className='vhl';
    const ico=document.createElement('span');ico.style.fontSize='18px';ico.textContent=gr.v.icon;
    const nm=document.createElement('span');nm.textContent=gr.v.name_en;
    hl.appendChild(ico);hl.appendChild(nm);
    const cnt=document.createElement('span');cnt.className='vhc';cnt.textContent=gr.items.length;
    hdr.appendChild(hl);hdr.appendChild(cnt);
    const bdy=document.createElement('div');bdy.className='vbdy';
    gr.items.forEach(k=>{
      const row=document.createElement('div');row.className='krow';
      const sp=document.createElement('span');sp.textContent=k.name;
      const act=document.createElement('div');act.className='kact';act.style.cssText='display:flex;gap:6px';
      const be=document.createElement('button');be.className='bsm';be.style.cssText='font-size:11px;padding:4px 10px';be.appendChild(svgIcon('edit',12));be.appendChild(document.createTextNode(' Izmeni'));be.onclick=()=>editKom(k.id);
      const bd=document.createElement('button');bd.className='bsm dng';bd.style.cssText='font-size:11px;padding:4px 10px';bd.appendChild(svgIcon('trash',12));bd.appendChild(document.createTextNode(' Obriši'));bd.onclick=()=>delKom(k.id,k.name);
      act.appendChild(be);act.appendChild(bd);
      row.appendChild(sp);row.appendChild(act);bdy.appendChild(row);
    });
    sec.appendChild(hdr);sec.appendChild(bdy);box.appendChild(sec);
  }
  if(!hasItems){const p=document.createElement('p');p.style.color='var(--tx3)';p.style.padding='20px';p.textContent='Nema rezultata';box.appendChild(p);}
}
export function showAddKom(){document.getElementById('mkTitle').textContent='Dodaj';document.getElementById('mkName').value='';document.getElementById('mkId').value='';document.getElementById('mkNotes').value='';popVS('mkVrsta');document.getElementById('mdlKom').classList.add('active');}
export function editKom(id){const k=state.komData.find(x=>x.id===id);if(!k)return;document.getElementById('mkTitle').textContent='Izmeni';document.getElementById('mkName').value=k.name;document.getElementById('mkId').value=k.id;document.getElementById('mkNotes').value=k.notes||'';popVS('mkVrsta',k.vrsta_troska_id);document.getElementById('mdlKom').classList.add('active');}

export async function saveKom(){
  const n=document.getElementById('mkName').value.trim();
  const v=document.getElementById('mkVrsta').value||null;
  const id=document.getElementById('mkId').value;
  if(!n){toast('Unesite naziv','err');return;}
  try{
    const notes=document.getElementById('mkNotes').value.trim();
    const{error}=await sb.rpc('upsert_komitent',{
      p_user_id:state.CU.id, p_name:n, p_vrsta_id:v?parseInt(v):null,
      p_komitent_id:id?parseInt(id):null, p_notes:notes
    });
    if(error)throw error;
    clMdl('mdlKom');await loadAllData();toast(id?'A\u017eurirano':'Dodato');
  }catch(e){toast(e.message||'Greška pri čuvanju','err');}
}

export async function delKom(id,name){
  showConfirm('Obrisati komitenta "'+name+'"? Ova akcija je nepovratna.', async () => {
    try{
      const{error}=await sb.rpc('delete_komitent',{p_user_id:state.CU.id,p_komitent_id:id});
      if(error)throw error;
      await loadAllData();toast('Obrisano');
    }catch(e){toast(e.message||'Greška pri brisanju','err');}
  });
}

// USERS MANAGEMENT
export function renderUsers(){
  if(!state.usersData.length){const box=document.getElementById('usrBox');box.textContent='';const p=document.createElement('p');p.style.cssText='text-align:center;padding:30px;color:var(--tx3)';p.textContent='Nema korisnika za prikaz.';box.appendChild(p);return;}
  const box=document.getElementById('usrBox');
  box.textContent='';
  state.usersData.forEach(u=>{
    const initials=u.full_name.split(' ').map(w=>w[0]).join('').substring(0,2).toUpperCase();
    const isSusp=!u.is_active;
    const card=document.createElement('div');card.className='usr-card'+(isSusp?' suspended':'');
    const info=document.createElement('div');info.className='usr-info';
    const av=document.createElement('div');av.className='usr-avatar';av.textContent=initials;
    const det=document.createElement('div');
    const nm=document.createElement('div');nm.className='usr-name';nm.textContent=u.full_name+' ';
    const st=document.createElement('span');st.style.fontWeight='600';st.style.fontSize='11px';st.style.padding='2px 8px';st.style.borderRadius='10px';
    if(isSusp){st.style.color='var(--dng)';st.style.background='var(--dng-bg)';st.textContent='SUSPENDOVAN';}
    else{st.style.color='var(--suc)';st.style.background='var(--suc-bg)';st.textContent='AKTIVAN';}
    nm.appendChild(st);
    const em=document.createElement('div');em.className='usr-email';em.textContent=u.email+' \u00B7 ';
    const rl=document.createElement('span');rl.style.color='var(--acc)';rl.textContent=u.role;em.appendChild(rl);
    det.appendChild(nm);det.appendChild(em);info.appendChild(av);info.appendChild(det);
    const meta=document.createElement('div');meta.className='usr-meta';
    const tbs=document.createElement('div');tbs.className='usr-tabs';
    (u.allowed_tabs||[]).forEach(t=>{const sp=document.createElement('span');sp.className='usr-tab';sp.textContent=t;tbs.appendChild(sp);});
    const acts=document.createElement('div');acts.className='usr-actions';
    const btnE=document.createElement('button');btnE.className='bsm';btnE.textContent='Izmeni';btnE.onclick=()=>editUser(u.id);
    const btnT=document.createElement('button');btnT.className='bsm'+(isSusp?'':' dng');btnT.textContent=isSusp?'Aktiviraj':'Suspenduj';btnT.onclick=()=>toggleUser(u.id,u.is_active,u.full_name);
    acts.appendChild(btnE);acts.appendChild(btnT);meta.appendChild(tbs);meta.appendChild(acts);
    card.appendChild(info);card.appendChild(meta);box.appendChild(card);
  });
}
export function showAddUser(){
  document.getElementById('muTitle').textContent='Novi korisnik';
  document.getElementById('muName').value='';document.getElementById('muEmail').value='';
  document.getElementById('muPass').value=Math.random().toString(36).slice(-8);
  document.getElementById('muRole').value='viewer';document.getElementById('muId').value='';
  renderTabChecks([]);document.getElementById('mdlUser').classList.add('active');
}
export function editUser(id){
  const u=state.usersData.find(x=>x.id===id);if(!u)return;
  document.getElementById('muTitle').textContent='Izmeni: '+u.full_name;
  document.getElementById('muName').value=u.full_name;document.getElementById('muEmail').value=u.email;
  document.getElementById('muPass').value='';document.getElementById('muPass').placeholder='(ostavi prazno)';
  document.getElementById('muRole').value=u.role;document.getElementById('muId').value=u.id;
  renderTabChecks(u.allowed_tabs||[]);document.getElementById('mdlUser').classList.add('active');
}
export function renderTabChecks(sel){
  const box=document.getElementById('muTabs');
  box.textContent='';
  ALL_TABS.filter(t=>t.id!=='users'&&t.id!=='istorija').forEach(t=>{
    const chk=sel.includes(t.id);
    const lbl=document.createElement('label');lbl.className='tab-check'+(chk?' checked':'');
    const inp=document.createElement('input');inp.type='checkbox';inp.value=t.id;if(chk)inp.checked=true;
    inp.onchange=function(){this.parentElement.classList.toggle('checked');};
    lbl.appendChild(inp);lbl.appendChild(document.createTextNode(' '+t.label));
    box.appendChild(lbl);
  });
}

export async function saveUser(){
  const name=document.getElementById('muName').value.trim();
  const email=document.getElementById('muEmail').value.trim();
  const pass=document.getElementById('muPass').value;
  const role=document.getElementById('muRole').value;
  const id=document.getElementById('muId').value;
  const tabs=[...document.querySelectorAll('#muTabs input:checked')].map(c=>c.value);
  if(role==='superadmin'||role==='admin'){if(!tabs.includes('users'))tabs.push('users');}
  if(!name||!email){toast('Popunite polja','err');return;}
  try{
    if(id){
      const{error}=await sb.rpc('update_user',{
        p_caller_id:state.CU.id,p_user_id:parseInt(id),
        p_name:name,p_email:email,p_role:role,p_tabs:tabs
      });
      if(error)throw error;
      if(pass){
        const{error:e2}=await sb.rpc('update_user_password',{p_user_id:parseInt(id),p_new_password:pass});
        if(e2)throw e2;
      }
    }else{
      if(!pass){toast('Unesite lozinku','err');return;}
      const{error}=await sb.rpc('create_user',{p_email:email,p_password:pass,p_name:name,p_role:role,p_tabs:tabs});
      if(error)throw error;
    }
    clMdl('mdlUser');
    const{data,error:le}=await sb.rpc('list_users',{p_caller_id:state.CU.id});
    if(le)throw le;
    state.usersData=data||[];renderUsers();
    toast(id?'Korisnik a\u017euriran':'Korisnik kreiran');
  }catch(e){
    const msg=e.message||'';
    if(msg.includes('app_users_email_key')||msg.includes('duplicate key')||msg.includes('već postoji'))
      toast('Korisnik sa ovim emailom već postoji','err');
    else toast(msg||'Greška','err');
  }
}

export async function toggleUser(id,isActive,name){
  const action=isActive?'suspendovati':'aktivirati';
  showConfirm(action.charAt(0).toUpperCase()+action.slice(1)+' korisnika "'+name+'"?', async () => { try{
    const{error}=await sb.rpc('toggle_user_active',{p_caller_id:state.CU.id,p_user_id:id,p_active:!isActive});
    if(error)throw error;
    const{data,error:le}=await sb.rpc('list_users',{p_caller_id:state.CU.id});
    if(le)throw le;
    state.usersData=data||[];renderUsers();
    toast(!isActive?'Nalog aktiviran':'Nalog suspendovan');
  }catch(e){toast(e.message||'Greška','err');} });
}

// QUICK ASSIGN
export function quickAssign(komName){
  const mdl=document.getElementById('mdlQuick');
  document.getElementById('mqName').textContent=komName;
  const sel=document.getElementById('mqVrsta');
  sel.textContent='';
  const def=document.createElement('option');def.value='';def.textContent='\u2014 Izaberi kategoriju \u2014';sel.appendChild(def);
  state.vrsteData.forEach(v=>{
    const o=document.createElement('option');o.value=v.id;o.textContent=v.icon+' '+v.name_en+' \u2014 '+v.name_sr;sel.appendChild(o);
  });
  document.getElementById('mqKomName').value=komName;
  mdl.classList.add('active');
}

export async function saveQuickAssign(){
  const name=document.getElementById('mqKomName').value;
  const vrstaId=document.getElementById('mqVrsta').value;
  if(!vrstaId){toast('Izaberi kategoriju','err');return;}
  try{
    // Try šifra match first (e.g. "1393 Foo" matches DB "1393 Foo Beograd"), fallback to exact name
    const sifraMatch=(name||'').match(/^\s*(\d+)\s+/);
    let existing=null;
    if(sifraMatch){
      const pref=sifraMatch[1]+' ';
      const{data}=await sb.from('komitenti').select('id,name').ilike('name',pref+'%').is('deleted_at',null).limit(1);
      if(data&&data.length)existing=data[0];
    }
    if(!existing){
      const{data}=await sb.from('komitenti').select('id,name').eq('name',name).is('deleted_at',null).maybeSingle();
      if(data)existing=data;
    }
    const vid=parseInt(vrstaId);
    // p_notes mora da se prosledi da PostgREST razlikuje od 4-arg overload-a
    const{error}=await sb.rpc('upsert_komitent',{
      p_user_id:state.CU.id, p_name:existing?existing.name:name, p_vrsta_id:vid,
      p_komitent_id:existing?existing.id:null, p_notes:''
    });
    if(error)throw error;
    clMdl('mdlQuick');
    // Azuriraj komData za buduce genReport pozive — koristi DB ime ako je postojao
    const effName=existing?existing.name:name;
    const ki=state.komData.findIndex(k=>k.name===effName);
    if(ki>=0) state.komData[ki].vrsta_troska_id=vid;
    else state.komData.push({name:effName, vrsta_troska_id:vid});
    // Direktno pomeri komitenta iz Nepoznati u pravu grupu
    const vrsta=state.vrsteData.find(v=>v.id===vid);
    if(state.lastReport&&vrsta){
      const unk=state.lastReport.groups['_unk'];
      const tgt=state.lastReport.groups[vrsta.name_en];
      if(unk&&tgt){
        const idx=unk.items.findIndex(k=>k.komitent===name);
        if(idx>=0){
          const item=unk.items.splice(idx,1)[0];
          unk.total-=item.dospelo;
          tgt.items.push(item);
          tgt.total+=item.dospelo;
          tgt.items.sort((a,b)=>b.dospelo-a.dospelo);
        }
      }
      renderReport(state.lastReport);
    }
    toast(name+' dodeljen kategoriji!');
    loadAllData();
  }catch(e){toast(e.message||'Greška pri dodeli','err');}
}

// BULK IMPORT KOMITENTI
export async function handleKomImport(inp){
  if(!inp.files.length)return;
  const f=inp.files[0];
  const r=new FileReader();r.onload=async e=>{
    try{
      const wb=XLSX.read(e.target.result,{type:'array'});
      const ws=wb.Sheets[wb.SheetNames[0]];
      const rows=XLSX.utils.sheet_to_json(ws,{header:1,raw:true,defval:''});
      if(rows.length<2){toast('Excel je prazan','err');return;}
      const hdr=rows[0].map(h=>String(h||'').toLowerCase().trim());
      const ci=name=>{for(let i=0;i<hdr.length;i++){if(hdr[i].includes(name))return i;}return -1;};
      const cName=ci('naziv')>=0?ci('naziv'):(ci('name')>=0?ci('name'):ci('komitent'));
      const cNotes=ci('napomena')>=0?ci('napomena'):(ci('notes')>=0?ci('notes'):-1);
      if(cName<0){toast('Excel nema kolonu "naziv" ili "name"','err');return;}
      const items=[];
      for(let i=1;i<rows.length;i++){
        const row=rows[i];
        const name=row[cName]!=null?String(row[cName]).trim():'';
        if(!name)continue;
        items.push({name,vrsta_id:null,notes:cNotes>=0?String(row[cNotes]||'').trim():''});
      }
      if(!items.length){toast('Nema stavki za import','err');return;}
      showConfirm('Importovati '+items.length+' komitenata? Postojeći sa istim imenom će biti ažurirani.', async () => {
        try{
          showLoading();
          const{data,error}=await sb.rpc('import_komitenti',{p_user_id:state.CU.id,p_data:items});
          if(error)throw error;
          await loadAllData();
          hideLoading();
          toast(items.length+' komitenata importovano');
        }catch(err){hideLoading();toast('Greška: '+err.message,'err');}
      });
    }catch(err){toast('Greška: '+err.message,'err');}
  };r.readAsArrayBuffer(f);
  inp.value='';
}

// MERGE KOMITENTI
export function showMergeKom(){
  if(state.komData.length<2){toast('Nema dovoljno komitenata','err');return;}
  const names=state.komData.map(k=>k.name.toLowerCase().trim());
  const dupes=[];
  for(let i=0;i<names.length;i++){
    for(let j=i+1;j<names.length;j++){
      if(names[i]===names[j]||(names[i].length>5&&names[j].includes(names[i]))||(names[j].length>5&&names[i].includes(names[j]))){
        dupes.push({a:state.komData[i],b:state.komData[j]});
      }
    }
  }
  if(!dupes.length){toast('Nema duplikata','suc');return;}
  let msg='Pronađeni mogući duplikati:\n\n';
  dupes.slice(0,10).forEach((d,i)=>{msg+=(i+1)+'. "'+d.a.name+'" i "'+d.b.name+'"\n';});
  if(dupes.length>10)msg+='\n...i još '+(dupes.length-10)+' parova';
  msg+='\n\nSpojiti prvi par? (zadrži prvog, obriši drugog)';
  showConfirm(msg, () => mergeKomPair(dupes[0].a.id,dupes[0].b.id));
}
export async function mergeKomPair(keepId,mergeId){
  try{
    const{error}=await sb.rpc('merge_komitenti',{p_user_id:state.CU.id,p_keep_id:keepId,p_merge_ids:[mergeId]});
    if(error)throw error;
    await loadAllData();toast('Komitenti spojeni');
  }catch(e){toast(e.message||'Greška','err');}
}

// BACKUP & RESTORE (superadmin only)
export async function backupData(){
  if(state.CU.role!=='superadmin'){toast('Samo superadmin može da pravi backup','err');return;}
  showLoading();
  try{
    const[vr,km,kp,hist,kf,ps]=await Promise.all([
      sb.from('vrste_troskova').select('*').is('deleted_at',null),
      sb.from('komitenti').select('*').is('deleted_at',null),
      sb.from('kontni_plan').select('*').is('deleted_at',null),
      sb.from('report_history').select('id,user_name,report_type,period_from,period_to,total_rsd,total_usd,kurs,file_name,created_at'),
      sb.from('komitenti_full').select('*').is('deleted_at',null),
      sb.from('pocetno_stanje').select('*')
    ]);
    const backup={
      version:2,
      created:new Date().toISOString(),
      created_by:state.CU.full_name,
      vrste_troskova:vr.data||[],
      komitenti:km.data||[],
      kontni_plan:kp.data||[],
      komitenti_full:kf.data||[],
      pocetno_stanje:ps.data||[],
      report_count:(hist.data||[]).length
    };
    const blob=new Blob([JSON.stringify(backup,null,2)],{type:'application/json'});
    const url=URL.createObjectURL(blob);
    const a=document.createElement('a');a.href=url;a.download='fintrack_backup_'+new Date().toISOString().slice(0,10)+'.json';a.click();
    URL.revokeObjectURL(url);
    hideLoading();
    sb.rpc('log_audit',{p_user_id:state.CU.id,p_action:'backup',p_entity_type:'system',p_entity_name:'full_backup'}).then(null, e => console.error('SBIS:', e));
    toast('Backup kreiran');
  }catch(e){hideLoading();toast('Greška: '+e.message,'err');}
}

export async function restoreData(inp){
  if(state.CU.role!=='superadmin'){toast('Samo superadmin može da radi restore','err');return;}
  if(!inp.files.length)return;
  const f=inp.files[0];
  const reader=new FileReader();reader.onload=async e=>{
    try{
      const backup=JSON.parse(e.target.result);
      if(!backup.version||!backup.vrste_troskova){toast('Neispravan backup fajl','err');return;}
      const kfCount=backup.komitenti_full?backup.komitenti_full.length:0;
      const psCount=backup.pocetno_stanje?backup.pocetno_stanje.length:0;
      const msg='Restore iz backup-a od '+backup.created+' (kreirao: '+backup.created_by+')\n\n'+
        'Vrste troškova: '+backup.vrste_troskova.length+'\n'+
        'Komitenti: '+backup.komitenti.length+'\n'+
        'Kontni plan: '+backup.kontni_plan.length+'\n'+
        'Baza komitenata: '+kfCount+'\n'+
        'Početno stanje: '+psCount+'\n\n'+
        'OVO ĆE ZAMENITI POSTOJEĆE PODATKE!';
      showConfirm(msg, async () => {
        showLoading();
        try {
          if(backup.kontni_plan.length){
            const kpItems=backup.kontni_plan.map(k=>({rsKonto:k.rs_konto,rsName:k.rs_name,enKonto:k.en_konto,enName:k.en_name,type:k.account_type}));
            await sb.rpc('import_kontni_plan',{p_user_id:state.CU.id,p_data:kpItems});
          }
          if(backup.komitenti_full&&backup.komitenti_full.length){
            await sb.from('komitenti_full').delete().neq('id',0);
            const kfItems=backup.komitenti_full.map(k=>({sifra:k.sifra,naziv:k.naziv,adresa:k.adresa,mesto:k.mesto,pib:k.pib,telefon:k.telefon,ptt_broj:k.ptt_broj,maticni_broj:k.maticni_broj,pdv_status:k.pdv_status,rok_placanja:k.rok_placanja,ziro_racun:k.ziro_racun,kontakt_osoba:k.kontakt_osoba}));
            await sb.rpc('import_komitenti_full',{p_data:kfItems});
          }
          if(backup.pocetno_stanje&&backup.pocetno_stanje.length){
            await sb.from('pocetno_stanje').delete().neq('id',0);
            const psItems=backup.pocetno_stanje.map(p=>({konto:p.konto,naziv_konta:p.naziv_konta,duguje:p.duguje,potrazuje:p.potrazuje,broj_racuna:p.broj_racuna||'',datum_racuna:p.datum_racuna||'',opis:p.opis||'',tip:p.tip||'S'}));
            await sb.rpc('import_pocetno_stanje',{p_data:psItems});
          }
          await loadAllData();
          hideLoading();
          sb.rpc('log_audit',{p_user_id:state.CU.id,p_action:'restore',p_entity_type:'system',p_entity_name:'from_backup_'+backup.created}).then(null, e => console.error('SBIS:', e));
          toast('Restore uspešan! Kontni plan ('+backup.kontni_plan.length+'), Baza komitenata ('+kfCount+'), Početno stanje ('+psCount+')');
        }catch(err){hideLoading();toast('Greška pri restore: '+err.message,'err');}
      });
    }catch(err){toast('Neispravan backup fajl: '+err.message,'err');}
  };reader.readAsText(f);
  inp.value='';
}
